import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('slider', {
  root: {
    variants: {
      marksLabelAlignment: ['center', 'inside'],
    },
    states: ['hasGradient', 'horizontal'],
  },
  mark: {},
  markLine: {},
  markValue: {},
  markLabel: {},
});

export const handleClasses = defineClassNames('slider-handle', {
  root: {
    states: ['disabled', 'hovered', 'hasGradient'],
  },
  handle: {},
  thumb: {},
  tooltip: {},
});
